<script>
import coverSheetManager from '@/data/json/document-validation/coverSheet/coverSheetManager.json'
import documentValidationResponseCodesJson from '@/data/json/document-validation/documentValidationResponseCodes.json'
import ValidationResultImage from '@/components/document-validation/validationResult/ValidationResultImage.vue'
import {mapGetters} from 'vuex'
import debounce from 'lodash.debounce'
import DocumentsListSidebar from './DocumentsListSidebar.vue'
import LetterAddressDetails from '@/components/document-validation/coverSheet/LetterAddressDetails.vue'
import LetterMetaDetails from '@/components/document-validation/coverSheet/LetterMetaDetails.vue'
import CoverSheetCardActions from '@/components/document-validation/coverSheet/CoverSheetCardActions.vue'
import CoverSheetTemplateUploader from '@/components/document-validation/coverSheet/CoverSheetTemplateUploader.vue'

export default {
  components: {
    CoverSheetTemplateUploader,
    CoverSheetCardActions,
    LetterMetaDetails,
    LetterAddressDetails,
    ValidationResultImage,
    DocumentsListSidebar
  },
  props: {
    isCoverSheetManagerDialogOpen: {type: Boolean},
    selected: {type: Array},
    order: {type: Object}
  },
  data: () => ({
    translation: coverSheetManager.data,
    validationTranslation: documentValidationResponseCodesJson.data,
    isLoading: false,
    isExecutingCallbacks: true,
    isCoverSheetTemplateUploaderOpen: false,
    errors: [],
    stationery: [],
    selectedDocument: {},
    selectedCoverSheetTemplate: null,
    selectedDetailsTab: 0,
    selectedPreviewTab: 0,
    previewImageURL: '',
    senderBlock: '', // single line
    addressBlock: '', // 4 lines, max 60 characters each
    address: {
      zipCode: '',
      city: '',
      country: 'Deutschland'
    },
    letter: {
      subject: '',
      date: '',
      body: ''
    }
  }),
  watch: {
    selected() {
      return this.selected[0] && this.selectDocument(this.selected[0])
    },
    selectedDocument() {
      if (this.isCoverSheetManagerDialogOpen) {
        this.previewCoverSheet()
      }
    },
    isCoverSheetManagerDialogOpen() {
      if (this.isCoverSheetManagerDialogOpen) {
        this.getStationery()
        this.errors = []
        this.selectedDocument.errors = []
        this.selectDocument(this.selected[0])
        this.setSenderBlock()
        this.setAddressBlock()
        setTimeout(() => this.previewCoverSheet(), 900)
      } else {
        this.selectedDocument = {}
        this.selectedCoverSheetTemplate = null
        this.isCoverSheetTemplateUploaderOpen = false
      }
    }
  },
  methods: {
    ...mapGetters(['profile', 'selectedOrganization']),
    getStationery() {
      this.$coverSheetService
          .getCoverSheets()
          .then((res) => {
            this.stationery = res
          })
          .catch((error) => {
            console.error('getStationery', error)
          })
    },
    currentSelectionIndex() {
      return this.selected.findIndex((item) => {
        if (item === this.selectedDocument) {
          return this.selectedDocument = this.selected
        }
      })
    },
    selectDocument(document) {
      this.selectedDocument = document
      // Load Preview Canvas
      if (this.$refs.resultImage) {
        this.$refs.resultImage.loadNextImage(0, true)
      }
      // Set Cover Sheet Template
      if (this.selectedDocument.coverSheetId !== null) {
        this.selectedCoverSheetTemplate = this.stationery.find((item) => item?.id === this.selectedDocument.coverSheetId)
      }
      // Update Form Fields
      if (document.recipientInfo && this.selectedDocument.coverSheetId !== null) {
        this.addressBlock = `${document.recipientInfo.recipient}\n${document.recipientInfo.street} ${document.recipientInfo.houseNumber}` || ''
        this.address.zipCode = document.recipientInfo.zipCode || ''
        this.address.city = document.recipientInfo.city || ''
      } else {
        this.addressBlock = ''
        this.address.zipCode = ''
        this.address.city = ''
      }
      this.setLetterMeta()
    },
    setLetterMeta() {
      this.$store.getters.mergedCoverSheets.forEach((item) => {
        if (item.documentId === this.selectedDocument.documentId) {
          this.letter = item.letterData
        }
      })
    },
    setSenderBlock() {
      if (this.$store.getters.mergedCoverSheets.length > 0) {
        return this.$store.getters.mergedCoverSheets.forEach((item) => {
          if (item.documentId === this.selectedDocument.documentId) {
            this.senderBlock = item.sender
          }
        })
      }

      if (this.selectedOrganization()) {
        return this.$organizationService.getBillingData(this.selectedOrganization().OrganizationId).then((res) => {
          this.senderBlock = `${res.billingCompanyName}, ${res.billingStreetAndNumber}, ${res.billingZipCode} ${res.billingCity}`
        })
      } else {
        if (this.profile().companyName) {
          return this.senderBlock = `${this.profile().companyName}, ${this.profile().address}, ${this.profile().zipCode} ${this.profile().city}`
        } else {
          return this.senderBlock = `${this.profile().salutation} ${this.profile().firstName} ${this.profile().lastName}, ${this.profile().address}, ${this.profile().zipCode} ${this.profile().city}`
        }
      }
    },
    setAddressBlock() {
      if (this.selectedDocument && this.selectedDocument.recipientInfo && this.selectedDocument.coverSheetId !== null) {
        this.addressBlock = `${this.selectedDocument.recipientInfo.recipient}\n${this.selectedDocument.recipientInfo.street} ${this.selectedDocument.recipientInfo.houseNumber}`
        this.address.zipCode = this.selectedDocument.recipientInfo.zipCode || ''
        this.address.city = this.selectedDocument.recipientInfo.city || ''
      }
    },
    setErrors(item) {
      if (item?.validationCode !== null) {
        return this.errors.push(this.$cms.get(this.validationTranslation, item.validationCode))
      }
      console.error('error when merging cover sheet', item)
      return this.errors.push('Bitte prüfen Sie Ihre Eingaben und versuchen es erneut.')
    },
    getPayload() {
      return {
        coverSheetId: this.selectedCoverSheetTemplate ? this.selectedCoverSheetTemplate.id : 0,
        sender: this.senderBlock,
        recipient: this.addressBlock + '\n\n' + this.address.zipCode + ' ' + this.address.city,
        dateString: this.letter.date,
        subject: this.letter.subject,
        freeText: this.letter.body,
        documentId: this.selectedDocument.documentId
      }
    },
    previewCoverSheet() {
      this.$coverSheetService.previewCoverSheet(this.getPayload())
          .then(response => {
            this.previewImageURL = URL.createObjectURL(response)
          })
          .catch(error => {
            console.error('previewCoverSheet', error)
          })
    },
    mergeCoverSheet(callbacks) {
      this.isLoading = true
      this.errors = []
      this.selectedDocument.errors = []

      this.$coverSheetService.mergeCoverSheet(this.getPayload())
          .then(response => {
            for (const item of response) {
              if (item.success) {
                this.selectedDocument.coverSheetStatus = item.validationCode
                if (this.addressBlock) {
                  const addressLines = this.addressBlock.split('\n');
                  const streetParts = addressLines[1] ? addressLines[1].split(' ') : ['', ''];

                  this.selectedDocument.recipientInfo = {
                    recipient: addressLines[0] || '',
                    street: streetParts[0] || '',
                    houseNumber: streetParts[1] || '',
                    zipCode: this.address.zipCode,
                    city: this.address.city
                  };
                } else {
                  this.selectedDocument.recipientInfo = {
                    recipient: '',
                    street: '',
                    houseNumber: '',
                    zipCode: this.address.zipCode,
                    city: this.address.city
                  };
                }
                // Set template
                this.selectedDocument.coverSheetId = this.selectedCoverSheetTemplate !== null ? this.selectedCoverSheetTemplate?.id : 0
              } else {
                this.setErrors(item)
                this.selectedDocument.coverSheetStatus = item.validationCode
                this.isExecutingCallbacks = false
              }
            }
            this.selectedDocument.sender = this.senderBlock
            // Handle callbacks list
            if (this.isExecutingCallbacks && callbacks.length > 0) callbacks.forEach((c) => c())
            // Assign letter meta
            this.selectedDocument.letterData = this.letter
            // Clear letter inputs but only if it's not the last document
            if (this.selected.length > 1) {
              this.letter = {
                subject: '',
                date: '',
                body: ''
              }
            }
            // Persist coversheet info in store
            this.$store.commit('ADD_MERGED_COVERSHEETS', this.selectedDocument)
          })
          .catch(error => {
            this.errors.push('Beim hinzufügen des Deckblattes ist ein Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.')
            this.selectedDocument.errors = [{title: error.title, message: error.message}]
            console.error('error when merging cover sheet', error)
          })
          .finally(() => {
            this.isLoading = false
            this.isExecutingCallbacks = true
          })
    },
    handlePreviousDocument() {
      this.selectDocument(this.selected[this.currentSelectionIndex() - 1])
    },
    handleNextDocument() {
      this.mergeCoverSheet([
        () => this.selectDocument(this.selected[this.currentSelectionIndex() + 1]),
        () => this.$emit('added-coversheet-to-document', this.selectedDocument, this.getPayload())
      ])
    },
    handleCheck() {
      this.mergeCoverSheet([
        () => this.$emit('added-coversheet-to-document', this.selectedDocument)
      ])
    },
    handleFinalize() {
      this.mergeCoverSheet([
        () => this.$emit('added-coversheet-to-document', this.selectedDocument),
        () => this.$emit('finalized-coversheet', this.selected),
        () => this.$emit('close-coversheet-manager')
      ])
    },
    handleSetCurrentDate() {
      this.letter.date = new Date().toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
      this.previewCoverSheet()
    },
    handleDebouncedPreviewCoverSheet: debounce(function () {
      this.previewCoverSheet()
    }, 500),
    handleDeleteDocument() {
      if (this.selected.length === 1) {
        return this.$emit('close-coversheet-manager')
      }
      return this.$coverSheetService.removeCoverSheetFromDocument(this.selectedDocument.documentId)
          .then(() => {
            this.selected.splice(this.selected.indexOf(this.selectedDocument), 1)
          }).catch(error => {
            console.error('delete document error: ', error)
          })
    },
    handleStationeryUploaded(stationery) {
      // eslint-disable-next-line no-prototype-builtins
      stationery.hasOwnProperty('id') ? this.selectedCoverSheetTemplate = stationery : this.selectedCoverSheetTemplate = null
      this.getStationery()
      this.previewCoverSheet()
      this.isCoverSheetTemplateUploaderOpen = false
    }
  }
}
</script>
<template>
  <v-overlay :value="isCoverSheetManagerDialogOpen" z-index="999">
    <v-card flat light min-width="80vw" class="cover-sheet-manager-card">
      <v-card-title class="justify-center primary overlay-title">{{ $cms.get(translation, 'administrate_coversheet') }}
        <v-btn
          icon
          class="close-btn overlay-title"
          @click="$emit('close-coversheet-manager')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <div class="pa-4">
        <v-row>
          <v-col cols="3">
            <!-- Documents Sidebar / Navigation-->
            <DocumentsListSidebar
              :selected="selected"
              :selected-document="selectedDocument"
              @select-document="selectDocument"
              @delete-document="handleDeleteDocument"
            />
          </v-col>
          <!-- PDF Preview Section -->
          <v-col cols="4">
            <v-card class="fill-height fullwidth-preview-wrapper">
              <v-card-title class="text-center">
                <div>
                  {{ $cms.get(translation, 'preview') }}
                  <span v-if="stationery.length > 0" style="color:black!important;right:10px;position:absolute;">
                  <v-select
                    v-model="selectedCoverSheetTemplate"
                    :items="stationery"
                    item-text="name"
                    item-value="id"
                    return-object
                    label="Deckblattvorlage auswählen"
                    dense
                    outlined
                    clearable
                    hide-details
                    @change="previewCoverSheet"></v-select>
                </span>
                </div>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="text-center">
                <!-- Placeholder for PDF preview -->
                <div v-if="!selectedDocument" class="pdf-preview">
                  <v-icon large>mdi-file-pdf-box</v-icon>
                  <p>{{ $cms.get(translation, 'pdf_preview') }}</p>
                </div>
                <div v-else>
                  <v-tabs
                    v-model="selectedPreviewTab"
                    show-arrows
                  >
                    <v-tab value="coversheet-preview" style="color:black!important">
                      {{ $cms.get(translation, 'tab_coversheet_preview') }}
                    </v-tab>
                    <v-tab value="document-preview" style="color:black!important">
                      {{ $cms.get(translation, 'tab_document_preview') }}
                    </v-tab>
                    <!-- Preview Coversheet -->
                    <v-tab-item v-show="selectedPreviewTab === 0" style="background:rgba(0,0,0,0.03)">
                      <v-divider/>
                      <img :src="previewImageURL" alt="" width="80%">
                    </v-tab-item>
                    <!-- Preview Document-->
                    <v-tab-item v-show="selectedPreviewTab === 1">
                      <v-divider/>
                      <ValidationResultImage
                        ref="resultImage"
                        :document-id="selectedDocument.documentId"
                        :page-count="selectedDocument.pageCount"
                        :max-height="600"
                      />
                    </v-tab-item>
                  </v-tabs>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- Input Fields Section -->
          <v-col cols="5">
            <v-card class="fill-height" style="overflow-y: auto;max-height:83vh;">
              <v-card-title class="text-center">
                <div>
                  {{ $cms.get(translation, 'coversheet_params') }}
                  <span style="color:black!important;right:10px;position:absolute;">
                  <a
                    v-if="!isCoverSheetTemplateUploaderOpen"
                    style="font-size:12px;"
                    @click.prevent="isCoverSheetTemplateUploaderOpen = true">
                    <v-icon color="primary">mdi-upload</v-icon>
                    <small class="text--primary">{{ $cms.get(translation, 'upload_coversheet') }}</small>
                  </a>
                    <a
                      v-if="isCoverSheetTemplateUploaderOpen"
                      style="font-size:12px;"
                      @click.prevent="isCoverSheetTemplateUploaderOpen = false">
                    <v-icon color="primary">mdi-close</v-icon>
                    <small class="text--primary">{{ $cms.get(translation, 'abort_upload') }}</small>
                  </a>
                </span>
                </div>
              </v-card-title>

              <v-divider></v-divider>
              <v-tabs
                v-show="!isCoverSheetTemplateUploaderOpen"
                v-model="selectedDetailsTab"
                show-arrows>
                <v-tab style="color:black!important">
                  {{ $cms.get(translation, 'tab_address_data') }}
                </v-tab>
                <v-tab style="color:black!important">
                  {{ $cms.get(translation, 'tab_document_data') }}
                </v-tab>
                <v-tab-item v-show="selectedDetailsTab === 0">
                  <v-divider/>
                  <!-- Letter Address Details-->
                  <LetterAddressDetails
                    :errors="errors"
                    :sender-block.sync="senderBlock"
                    :address-block.sync="addressBlock"
                    :address.sync="address"
                    :selected-document="selectedDocument"
                    :selected-stationery="selectedCoverSheetTemplate"
                    @debounced-preview-cover-sheet="handleDebouncedPreviewCoverSheet"
                  />
                </v-tab-item>
                <v-tab-item v-show="selectedDetailsTab === 1">
                  <v-divider/>
                  <!--Letter Details-->
                  <LetterMetaDetails
                    :letter.sync="letter"
                    :selected-document="selectedDocument"
                    @debounced-preview-cover-sheet="handleDebouncedPreviewCoverSheet"
                    @set-current-date="handleSetCurrentDate"
                  />
                </v-tab-item>
              </v-tabs>
              <CoverSheetTemplateUploader
                v-show="isCoverSheetTemplateUploaderOpen"
                :sender-block.sync="senderBlock"
                @stationery-uploaded="handleStationeryUploaded"
              />
              <!-- CardActions / Navigation -->
              <CoverSheetCardActions
                v-show="!isCoverSheetTemplateUploaderOpen"
                :selected="selected"
                :selected-document="selectedDocument"
                :is-loading="isLoading"
                @next-document="handleNextDocument"
                @previous-document="handlePreviousDocument"
                @check="handleCheck"
                @finalize="handleFinalize"
              />
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-overlay>
</template>
<style scoped>
.pdf-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f9f9f9;
}

.close-btn {
  position: absolute;
  right: 12px;
  top: 14px;
}

.overlay-title {
  color: white !important;
}

.cover-sheet-manager-card {
  position: relative;
  max-height: 96vh;
  overflow-y: hidden;
  width: 90vw;
}
</style>
<style>
.fullwidth-preview-wrapper div.v-card__text.text-center {
  margin: 0;
  padding: 0 !important;
}
</style>
